import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import {
  adminButtonBaseSx,
  adminButtonSizes,
  adminButtonVariants,
} from './adminButtonStyles';

/**
 * Standardized button for the Admin Panel.
 *
 * Variants: primary | secondary | outline | danger | dangerSolid | ghost
 * Sizes: sm | md | lg
 */
export default function AdminAction({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  startIcon,
  endIcon,
  fullWidth = false,
  children,
  sx,
  ...props
}) {
  const config = adminButtonVariants[variant] || adminButtonVariants.primary;
  const sizeSx = adminButtonSizes[size] || adminButtonSizes.md;

  return (
    <Button
      variant={config.muiVariant}
      disabled={disabled || loading}
      startIcon={loading ? undefined : startIcon}
      endIcon={endIcon}
      fullWidth={fullWidth}
      sx={{
        ...adminButtonBaseSx,
        ...sizeSx,
        ...config.sx,
        ...(fullWidth ? { width: '100%' } : {}),
        ...sx,
      }}
      {...props}
    >
      {loading ? (
        <CircularProgress
          size={size === 'sm' ? 14 : 16}
          sx={{ color: variant === 'outline' || variant === 'danger' ? '#57534e' : '#fff' }}
        />
      ) : (
        children
      )}
    </Button>
  );
}

/** Consistent spacing wrapper for form action rows. */
export function AdminActionGroup({ children, align = 'end', sx }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: align === 'end' ? 'flex-end' : align === 'start' ? 'flex-start' : 'center',
        gap: '12px',
        flexWrap: 'wrap',
        ...sx,
      }}
    >
      {children}
    </div>
  );
}

/** Standard form footer used on create/edit screens. */
export function AdminFormFooter({ children, className = '' }) {
  return (
    <div className={`px-6 py-4 bg-stone-50 border-t border-stone-100 flex justify-end ${className}`.trim()}>
      <AdminActionGroup>{children}</AdminActionGroup>
    </div>
  );
}
